import { BaseLayoutFactory } from "../global/base-layout-factory";
import { PurchaseContractsProvider } from "./context/purchase-contracts-context";
import { PurchaseContractDetailComponent } from "./purchase-contract-detail-component";

export function PurchaseContractDetailFactory() {
    return (
        <BaseLayoutFactory>
            <PurchaseContractsProvider>
                <PurchaseContractDetailComponent />
            </PurchaseContractsProvider>
        </BaseLayoutFactory>
    );
}
